import React from "react";
import { motion } from "framer-motion";

// Slide-up reveal used to present each section like a "carrossel de baixo para cima".
export default function Reveal({ children, delay = 0, y = 64, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-90px" }}
      transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}
